/**
 * 水平填充
 */
import fvAnimation from "./fvAnimation"
export default class fvHorFill extends fvAnimation {
    constructor(shape){
        super(shape,"fvHorFill");
        this.sizeFunction = AsyncFunction("return " + this.expression);
        this.realMin = AsyncFunction("return " + this.realMin);
        this.realMax = AsyncFunction("return " + this.realMax);
        this.getData();
    }

    async getData(){
        this.size = await this.executionScript(this.sizeFunction);
        this.realMinValue = await this.executionScript(this.realMin);
        this.realMaxValue = await this.executionScript(this.realMax);
    }

    async run(canvas,value){
        //if(value == false) return;
        this.getData();
        
    }

    runEnd(canvas){
        console.log(this.shape);
        if(this.size == -9999 || this.size == undefined){
            this.size = 0;
        }
        if(this.size >= this.realMaxValue){
            this.size = this.realMaxValue;
        }
        if(this.size <= this.realMinValue){
            this.size = this.realMinValue;
        }

        var param1 = parseFloat(this.viewMax) - parseFloat(this.viewMin);
        var param2 = this.size - parseFloat(this.realMinValue);
        var param3 = parseFloat(this.realMaxValue) - parseFloat(this.realMinValue);
        var viewNum = param1 * param2 / param3 + parseFloat(this.viewMin);
        
        canvas.fillStyle = this.fillcolor;
        var rect = {
            x : 0,
            y : 0,
            w : 0,
            h : 0
        }
        if(this.shape.fctype == "fvRectObj"){
            switch(this.beginPath){
                case "left" :
                    rect = {
                        x : this.shape.cx + this.shape.borderWidth / 2,
                        y : this.shape.cy + this.shape.borderWidth / 2,
                        w :viewNum/100*this.shape.regionWidth,
                        h : parseFloat(this.shape.regionHeight)
                    }
                break;
                case "right" :
                    rect = {
                        x : this.shape.cx + this.shape.regionWidth + this.shape.borderWidth / 2,
                        y : this.shape.cy + this.shape.borderWidth / 2,
                        w : -viewNum/100*this.shape.regionWidth,
                        h : parseFloat(this.shape.regionHeight)
                    }
                break;
            }
            canvas.fillRect(rect.x,rect.y,rect.w,rect.h);
        }else if(this.shape.fctype=="fvEllipseObj"){
            canvas.save();
            canvas.clip();
            this.shape.x = (this.shape.originalSize.x * this.shape.magnification.x);
            this.shape.y = (this.shape.originalSize.y * this.shape.magnification.y);
            this.shape.width = (this.shape.originalSize.width * this.shape.magnification.x);
            this.shape.height = (this.shape.originalSize.height * this.shape.magnification.y);
            this.shape.borderWidth = (this.shape.originalSize.borderWidth * this.shape.magnification.x);
            let aa = this.shape.width/2
            if(this.shape.width<this.shape.height){
                aa = this.shape.height/2
            }
            switch(this.beginPath){
                case "right" :
                    rect = {
                        x : this.shape.centerX-(aa),
                        y : (this.shape.centerY + this.shape.borderWidth)-(this.shape.height/1.2),
                        w : viewNum/100*this.shape.width,
                        h : (this.shape.height + this.shape.borderWidth)*2
                    }
                break;
                case "left" :
                    
                    rect = {

                        x : this.shape.centerX+(aa),
                        y : (this.shape.centerY + this.shape.borderWidth)-(this.shape.height/1.2),
                        w : -viewNum/100*this.shape.width,
                        h : (this.shape.height + this.shape.borderWidth)*2,
                    }
                break;
            }
           
            canvas.fillRect(rect.x,rect.y,rect.w,rect.h);
            canvas.restore();
        }else{
            canvas.save();
            canvas.clip();
            switch(this.beginPath){
                case "right" :
                    rect = {
                        x : this.shape.cx,
                        y : this.shape.cy + this.shape.borderWidth,
                        w : viewNum/100*this.shape.Width,
                        h : this.shape.Height + this.shape.borderWidth
                    }
                break;
                case "right" :
                    rect = {
                        x : this.shape.cx + this.shape.Width + this.shape.borderWidth,
                        y : this.shape.cy,
                        w : -viewNum/100*this.shape.Width,
                        h : this.shape.Height + this.shape.borderWidth
                    }
                break;
            }
            canvas.fillRect(rect.x,rect.y,rect.w,rect.h);
            this.shape.onDraw(canvas)
            canvas.restore();
        }
        
    }
}


// WEBPACK FOOTER //
// ./src/js/canvas/animation/fvHorFill.js